// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__KOUuq","errors":"Errors_errors__1gRSg"};